import React from "react"
import PropTypes from "prop-types"

import PathTransformer from "./parsers/PathTransformer"

import { Link, Trans } from "gatsby-plugin-react-i18next"

import * as topMenuStyles from "../styles/TopMenu.module.css"

const flatListToHierarchical = (
  data = [],
  { idKey = "id", parentKey = "parentId", childrenKey = "children" } = {}
) => {
  const tree = []
  const childrenOf = {}
  data.forEach(item => {
    const newItem = { ...item }
    const { [idKey]: id, [parentKey]: parentId = 0 } = newItem
    childrenOf[id] = childrenOf[id] || []
    newItem[childrenKey] = childrenOf[id]
    parentId
      ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
      : tree.push(newItem)
  })
  return tree
}

const SimpleLink = props => (
  <a
    href={props.destination}
    className={`menu-item-with-children ${
      props.activeMenuId === props.menuId ||
      (props.rootMenuId === props.menuId && !props.activeMenuId)
        ? topMenuStyles.menuItemActive
        : ``
    }`}
    onClick={evt => {
      // console.log(props.canHover, evt)
      if (!props.canHover) {
        evt.preventDefault()
        props.onToggle(props.menuId)
      }
    }}
    onMouseEnter={evt => {
      evt.preventDefault()
      props.onMouseEnter(props.menuId)
    }}
    onMouseLeave={evt => {
      evt.preventDefault()
      props.onMouseLeave(props.menuId)
    }}
  >
    {props.children}
  </a>
)

const PageMenuReferencedId = menuItem => {
  if (!menuItem.connectedNode || !menuItem.connectedNode.node) return null
  return menuItem.connectedNode.node.id || null
}

const TopMenu = props => {
  const {
    menuItems,
    pageContext,
    rootMenuItemId,
    extendedMenuItemId,
    activePageId,
  } = props
  const hierarchicalMenuItems = flatListToHierarchical(menuItems)

  return (
    <div className={topMenuStyles.wrapper}>
      {hierarchicalMenuItems.map((item, idx) => {
        return item.children.length === 0 ? (
          <Link
            key={idx}
            className={`${
              activePageId === PageMenuReferencedId(item) && !extendedMenuItemId
                ? topMenuStyles.menuItemActive
                : ``
            }`}
            to={PathTransformer(
              item.path,
              pageContext.language,
              pageContext.i18n.defaultLanguage,
              pageContext.i18n.languages
            )}
          >
            <Trans>{item.label}</Trans>
          </Link>
        ) : (
          <SimpleLink
            key={idx}
            menuId={item.id}
            rootMenuId={rootMenuItemId}
            activeMenuId={extendedMenuItemId}
            destination={PathTransformer(
              item.path,
              pageContext.language,
              pageContext.i18n.defaultLanguage,
              pageContext.i18n.languages,
              false
            )}
            canHover={props.canHover}
            onToggle={props.onToggle}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
          >
            <Trans>{item.label}</Trans>
          </SimpleLink>
        )
      })}
    </div>
  )
}

export default TopMenu

TopMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      parentId: PropTypes.string,
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      connectedNode: PropTypes.shape({
        node: PropTypes.shape({
          id: PropTypes.string.isRequired,
          excerpt: PropTypes.string,
        }),
      }),
    }).isRequired
  ).isRequired,
  rootMenuItemId: PropTypes.string,
  extendedMenuItemId: PropTypes.string,
  activePageId: PropTypes.string,
  canHover: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
}
